import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex gap-10 flex-col max-w-5xl mx-auto justify-center mt-28 ml-[30%]" }
const _hoisted_2 = {
  key: 0,
  class: "text-xl uppercase font-semibold text-[#322121] dark:text-white"
}
const _hoisted_3 = {
  key: 1,
  class: "text-xl uppercase font-semibold text-[#322121] dark:text-white"
}
const _hoisted_4 = { class: "text-left h-96 dark:text-white" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "block mb-2 text-left text-sm font-medium text-gray-900 dark:text-white",
  for: "user_avatar"
}, "Description", -1)

import { initTooltips } from "flowbite";
import { onMounted } from "vue";
import { QuillEditor } from '@vueup/vue-quill';
import { reactive, ref, computed } from 'vue';
import axios from 'axios';
import { useRoute, useRouter } from "vue-router";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Button from "@/components/Inputs/Button.vue";
import InputField from "@/components/Inputs/InputField.vue";
import SelectField from "@/components/Inputs/SelectField.vue";
import { url } from '@/functions/endpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDepartments',
  setup(__props) {

const uploading = ref(false);
let successMessage = ref<string>('');
let showSuccessMessage = ref<boolean>(false);
let errorAlert = ref<boolean>(false);
let errorMessage = ref<string>('');
let isUnit = ref<boolean>(false)
const isEditing = ref<boolean>(false);
const route = useRoute();
const postId = computed(() => route.params.id);
const editType = computed(() => route.name);
console.log(editType, 'edit');

const router = useRouter();
const data = reactive({
  title: '',
  description: '',
  department: ''
})

onMounted(() => {
  initTooltips();
  getDepartmentDetails();
});

const handleChecked = () => {
  isUnit.value = !isUnit.value;
}

const departmentInfo = ref([]);
const getDepartmentDetails = async () => {
  if (postId.value !== undefined) {
    isEditing.value = true;
    if (isEditing.value) {
      try {
        const response = await axios.get( editType.value === "EditDepartment" ? `${url}/departments/${postId.value}` : `${url}/unit/${postId.value}`);
        const documentData = response.data;
        departmentInfo.value = documentData
        data.title = editType.value === "EditDepartment" ? documentData.name : documentData.title;
        data.description = documentData.about;
        data.department = documentData?.department?.id;
      } catch (error: any) {
        errorAlert.value = true;
        errorMessage.value = error.message
      }
    } else {
      console.log('creating');
    }
  }
}

const handleAddUnit = async () => {
  try {
    if (!isEditing.value) {
      await axios.post(`${url}/unit`, { title: data.title, about: data.description, departmentId: parseInt(data.department) })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    } else {
      await axios.patch(`${url}/unit/update/${postId.value}`, { title: data.title, about: data.description, departmentId: parseInt(data.department) })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    }

    setTimeout(() => {
      showSuccessMessage.value = false;

      if (isEditing.value) {
        router.push('/admin/view-departments');
      } else {
        window.location.href = "/admin/add-department"
      }
    }, 1000);
  }
  catch (error: any) {
    errorAlert.value = true;
    errorMessage.value = error.message;
    setTimeout(() => {
      errorAlert.value = false;
    }, 5000)
  }
};

const handleAddDepartment = async () => {
  try {
    if (!isEditing.value) {
      await axios.post(`${url}/departments/create/department`, { name: data.title, about: data.description, })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    } else {
      await axios.patch(`${url}/departments/update/${postId.value}`, { name: data.title, about: data.description, })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    }
    setTimeout(() => {
      showSuccessMessage.value = false;

      if (isEditing.value) {
        router.push('/admin/view-departments');
      } else {
        window.location.href = "/admin/add-department"
      }
    }, 1000);
  }
  catch (error: any) {
    errorAlert.value = true;
    errorMessage.value = error.message;
    setTimeout(() => {
      errorAlert.value = false;
    }, 5000)
  }
};

const allDepartments: any = ref([]);
axios.get(`${url}/departments`)
  .then((response: any) => {
    allDepartments.value = response.data;
    console.error(allDepartments.value);
  })
  .catch((error: string) => {
    console.error(error);
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isUnit) || _unref(editType) === 'EditUnit')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(isEditing.value ? "Edit Unit" :
      "Add Unit"), 1))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(isEditing.value ? "Edit Department" :
      "Add Department"), 1)),
      (!isEditing.value)
        ? (_openBlock(), _createBlock(InputField, {
            key: 2,
            className: 'w-fit',
            label: "Is this a unit? NB: Check this to create a unit, uncheck it to create a department",
            id: "isUnitCheckbox",
            value: _unref(isUnit),
            type: "checkbox",
            placeholder: "Unit",
            isRequired: false,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isUnit) //@ts-ignore
 ? isUnit.value = $event.target.checked : isUnit = $event.target.checked))
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createVNode(InputField, {
        label: "Title",
        id: "title",
        type: "text",
        placeholder: _unref(isUnit) ? 'Enter unit title' : 'Enter department title',
        isRequired: true,
        modelValue: data.title,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.title) = $event))
      }, null, 8, ["placeholder", "modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(QuillEditor), {
          contentType: "html",
          theme: "snow",
          content: data.description,
          "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((data.description) = $event))
        }, null, 8, ["content"])
      ]),
      (_unref(isUnit) || _unref(editType) === 'EditUnit')
        ? (_openBlock(), _createBlock(SelectField, {
            key: 3,
            className: 'mt-20',
            label: "Select department",
            id: "departments",
            placeholder: "Select department",
            modelValue: data.department,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.department) = $event)),
            options: allDepartments.value,
            param: 'name'
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      (_unref(isUnit) || _unref(editType) === 'EditUnit')
        ? (_openBlock(), _createBlock(Button, {
            key: 4,
            className: 'mt-20',
            buttonText: isEditing.value ? 'Update Unit' : 'Add Unit',
            isDisabled: data.title === '' || data.description === '' || !data.department || uploading.value,
            uploading: uploading.value,
            handleClick: handleAddUnit
          }, null, 8, ["buttonText", "isDisabled", "uploading"]))
        : (_openBlock(), _createBlock(Button, {
            key: 5,
            className: 'mt-20',
            buttonText: isEditing.value ? 'Update Department' : 'Add Department',
            isDisabled: data.title === '' || data.description === '' || uploading.value,
            uploading: uploading.value,
            handleClick: handleAddDepartment
          }, null, 8, ["buttonText", "isDisabled", "uploading"]))
    ]),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})